export default __webpack_public_path__ + "static/media/oup.65f753d3.svg";